// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    --gw-weight-450: 450;
    --gw-weight-550: 550;
    --gw-weight-650: 650;
    --gw-weight-700: 700;
}
`, "",{"version":3,"sources":["webpack://./src/themes/default_v2/weight.css"],"names":[],"mappings":"AAAA;;IAEI,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;AACxB","sourcesContent":[":root,\n:host {\n    --gw-weight-450: 450;\n    --gw-weight-550: 550;\n    --gw-weight-650: 650;\n    --gw-weight-700: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
